import { Component, Input, OnInit } from '@angular/core';
import { ALL_GAMES } from '@app/core';
import { UserService } from '@app/core/services';
import { CommonService } from '@app/core/services/common.service';
import { ReplaySubject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-all-games',
  templateUrl: './all-games.component.html',
  styleUrls: ['./all-games.component.scss'],
})
export class AllGamesComponent implements OnInit {
  protected destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  customOptions = ALL_GAMES;
  sports: any[] = [];
  title: string = '';
  @Input() user_id: any;
  logos = {
    nba: '/assets/img/sports/nba.png',
    nhl: '/assets/img/sports/nhl.png',
    ncaab: '/assets/img/sports/ncaa.png',
    ncaaf: '/assets/img/sports/ncaa.png',
    tennis: '/assets/img/sports/tennis.png',
    soccer: '/assets/img/sports/soccer.png',
    mma: '/assets/img/sports/mma.jpg',
    boxing: '/assets/img/sports/boxing.png',
    mlb: '/assets/img/sports/mlb.png',
    nfl: '/assets/img/sports/nfl.png',
    cricket: '/assets/img/sports/cricket.jpg',
    nrl: '/assets/img/sports/nrl.png',
    afl: '/assets/img/sports/afl.png',
  };
  constructor(public _common: CommonService, private _user: UserService) { }
  ngOnInit(): void {
    this.customOptions.nav = true;
    this.customOptions.responsive = {
      0: {
        items: 2,
        autoWidth: true,
      },
      768: {
        items: 3,
        autoWidth: true,
      },
      992: {
        items: 3,
        autoWidth: true,
      },
      1200: {
        items: 4,
        autoWidth: false,
      },
    };
    if (this._common.isBrowser) {
      this._common.configuration.pipe(takeUntil(this.destroyed$)).subscribe(
        (data) => {
          this.sports = data?.sports || [];
          this._user.userDetails(this.user_id).then((res: any) => {
            let user = res.data;
            this.title = `${user.name}'s rank by Sports`;
            this.sports = this.sports.map((sport: any) => {
              sport.rank = user[sport.value?.toLowerCase() + '_rank'];
              sport.winnings =
                user[sport.value?.toLowerCase() + '_total_winnings'];
              return sport;
            });
          });
        }
      );
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
